module.exports = __webpack_public_path__ + "static/src/content/images/processed/400/The-Hot-Zone.b136eea.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/400/The-Hot-Zone.jpg
// module id = PSy7
// module chunks = 0